import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import { getCrafts } from "@/pages/task-list/repositorie/TaskListRepositorie";
import type { StatusCode } from "@/pages/work-orders/models/Filters";
import type { Craft } from "@/shared/work-orders-modals/models/Craft";
import { get } from "lodash-es";

type Props = {
	setIsCraftLoading: (isLoading: boolean) => void;
	setCraftError: (err: string) => void;
};

export const useLoadfilters = ({ setIsCraftLoading, setCraftError }: Props) => {
	const {
		actions: {
			setCraftsWorkOrders,
			setTypesCodesWorkOrders,
			setStatusCodesWorkOrders,
			setStatusCodeWorkOrders,
		},
	} = useAssetDetailsContext();

	const loadFilterCrafts = async () => {
		setIsCraftLoading(true);
		const res = await getCrafts();
		if (res.ok) {
			let craftSource = get(res, "data.tables[0].rows", null);
			craftSource.forEach((row: Craft) => {
				row.id = row.CraftId;
				row.description = row.CraftName;
				row.color = row.Color;
			});
			craftSource = craftSource.map(
				({ id, description, color, Code }: Craft) => ({
					id,
					description,
					color,
					code: Code,
				}),
			);
			craftSource.push({ id: "A", description: "All crafts" });
			setCraftsWorkOrders(craftSource);
			setIsCraftLoading(false);
		} else {
			setCraftError(res.message);
			setIsCraftLoading(false);
		}

		const typeSource = [];
		typeSource.push({ id: "PM", description: "PM" });
		typeSource.push({ id: "RM", description: "RM" });
		typeSource.push({ id: "A", description: "All types" });
		setTypesCodesWorkOrders(typeSource);
	};

	const loadFilterCloser = () => {
		const listStatusCode = [
			{ id: "C", description: "Closed" },
			{ id: "O", description: "Open" },
			{ id: "A", description: "All status" },
		];
		setStatusCodesWorkOrders(listStatusCode as StatusCode[]);
		setStatusCodeWorkOrders("O");
	};

	return { loadFilterCrafts, loadFilterCloser };
};
